// extracted by mini-css-extract-plugin
export var Content = "content-module--Content--2MgLg";